/**
 *
 * KronoMetro
 *
 * Copyright © 2019-present KronoMetro, Co. All rights reserved.
 *
 */
"use client";

import * as React from "react";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import CircularProgress from "@mui/material/CircularProgress";
import Fab from "@mui/material/Fab";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import NotificationImportantRoundedIcon from "@mui/icons-material/NotificationImportantRounded";

import logjs from "@metrojs/logjs";

const log = new logjs("Confirm");

Confirm.propTypes = {
  message: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onCancelButton: PropTypes.func,
  buttonName: PropTypes.string,
  color: PropTypes.string,
  onResolve: PropTypes.func,
};

function Confirm({ ...props }) {
  const { isOpen, message, onCancelButton, onResolve, buttonName, color = "primary" } = props;

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(true);
  const timer = React.useRef();

  React.useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  if (!isOpen) {
    return null;
  }

  const myColor = color;

  const onClickIcon = () => {
    clearTimeout(timer.current);
    setSuccess(false);
    setLoading(true);
    timer.current = setTimeout(() => {
      setSuccess(true);
      setLoading(false);
    }, 1200);
  };

  const handleCancel = () => {
    if (onCancelButton) {
      onCancelButton();
    }
    if (onResolve) {
      onResolve(false);
    }
  };

  const handleConfirm = () => {
    if (onResolve) {
      onResolve(true);
    }
  };

  //log.debug("props", props);

  return (
    <Dialog open={isOpen} fullWidth={false} maxWidth="md" aria-labelledby="alert-dialog-title">
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <FormGroup
            row
            sx={{
              margin: 1,
              position: "relative",
            }}
          >
            <Fab
              aria-label="confirm"
              color={myColor}
              size="small"
              sx={{
                boxShadow: "none",
              }}
            >
              {success ? (
                <NotificationsActiveRoundedIcon
                  sx={{
                    color: myColor,
                    fontSize: 28,
                  }}
                  onClick={onClickIcon}
                />
              ) : (
                <NotificationImportantRoundedIcon
                  sx={{
                    color: myColor,
                    fontSize: 28,
                  }}
                  onClick={onClickIcon}
                />
              )}
            </Fab>
            {loading && (
              <CircularProgress
                size={43}
                sx={{
                  color: "white",
                  position: "absolute",
                  top: -1,
                  left: -1,
                  zIndex: 1,
                }}
              />
            )}

            <Box
              sx={{
                marginLeft: "32px",
                marginTop: "16px",
                fontSize: "20px",
              }}
            >
              <span dangerouslySetInnerHTML={{ __html: message }}></span>
            </Box>
          </FormGroup>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          margin: "0 auto",
        }}
      >
        <FormGroup row>
          <Button variant="contained" color={myColor} onClick={handleConfirm} sx={{ marginLeft: "8px" }}>
            {buttonName || "ＯＫ"}
          </Button>
          <Button variant="outlined" color={myColor} onClick={handleCancel} autoFocus sx={{ marginLeft: "8px" }}>
            キャンセル
          </Button>
        </FormGroup>
      </DialogActions>
    </Dialog>
  );
}

export default Confirm;
